import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import nl from "./nl.json";
import fr from "./fr.json";
import en from "./en.json";
import it from "./it.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      nl: { translation: nl },
      fr: { translation: fr },
      en: { translation: en },
      it: { translation: it },
    },
    // V2.13 — Fallback to FR (not NL) so that any missing key on a
    // non-Dutch page never leaks Dutch text. Historically this was "nl"
    // and caused sporadic Dutch labels (e.g. savings/economies) on FR views
    // whenever a namespace happened to be short in fr.json.
    fallbackLng: "fr",
    supportedLngs: ["nl", "fr", "en", "it"],
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      caches: ["localStorage"],
      lookupQuerystring: "lang",
      lookupLocalStorage: "solarsim_lang",
    },
  });

// Keep <html lang> in sync with the resolved language for a11y + SEO.
if (typeof document !== "undefined") {
  const applyLang = (lng) => {
    try { document.documentElement.setAttribute("lang", (lng || "fr").split("-")[0]); } catch {}
  };
  applyLang(i18n.resolvedLanguage || i18n.language);
  i18n.on("languageChanged", applyLang);
}

export default i18n;
